module.exports = {
  siteMetadata: {
    title: `CAMARADES BR`,
    description: `A CAMARADES é uma organização sem fins lucrativos, fruto da colaboração entre cientistas, para promover a revisão sistemática da literatura (RSL) de estudos não clínicos na área de saúde.`,
    keywords: "organização, meta-análise, pesquisa brasileira, protocolo, pesquisa, farmacologia, clínico, laboratório, UFSC, syrf, sysphar, Revisões Sistemáticas em Farmacologia, wiki, organization, meta-analysis, protocol, research, pharmacology, clinic, laboratory, UFSC, syrf, sysphar, Systematic Reviews in Pharmacology, wiki, brazilian research",
    image: "/static/banner.png",
    author: `Victoria Botelho Martins, Bruna F Braga, CAMARADES`,
    siteUrl: `https://camaradesbrasil.bio.br/`,
  },
  plugins: [
    `gatsby-plugin-react-helmet`,
    'gatsby-plugin-sitemap',
    `gatsby-plugin-image`,
    {
      resolve: "gatsby-plugin-netlify-cms",
      options: {
        modulePath: `${__dirname}/src/cms/cms.js`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `uploads`,
        path: `${__dirname}/static/uploads`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/assets/images`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `tools-and-resources`,
        path: `${__dirname}/src/markdown/tools-and-resources`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `posts`,
        path: `${__dirname}/src/markdown/posts`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `projects`,
        path: `${__dirname}/src/markdown/projects`,
      },
    },
    `gatsby-transformer-remark`,
    `gatsby-plugin-image`,
    `gatsby-plugin-sharp`,
    `gatsby-transformer-sharp`,
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: `gatsby-starter-default`,
        short_name: `starter`,
        start_url: `/`,
        background_color: `#07BCFF`,
        // This will impact how browsers show your PWA/website
        // https://css-tricks.com/meta-theme-color-and-trickery/
        // theme_color: `#07BCFF`,
        display: `minimal-ui`,
        icon: `src/assets/images/globes/globe.png`, // This path is relative to the root of the site.
      },
    },
    //"gatsby-plugin-netlify", // make sure to keep it last in the array
    // this (optional) plugin enables Progressive Web App + Offline functionality
    // To learn more, visit: https://gatsby.dev/offline
    // `gatsby-plugin-offline`,
  ],
}
